var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconCampaign = function SvgIconCampaign(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "37px",
    viewBox: "0 0 36 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dock",
    transform: "translate(-312.000000, -370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(330.000000, 388.500000) rotate(33.000000) translate(-330.000000, -388.500000) translate(318.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 11,
    y: 4,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "track_changes_black_24dp-copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.07,4.93 L17.66,6.34 C19.1,7.79 20,9.79 20,12 C20,16.42 16.42,20 12,20 C7.58,20 4,16.42 4,12 C4,7.92 7.05,4.56 11,4.07 L11,6.09 C8.16,6.57 6,9.03 6,12 C6,15.31 8.69,18 12,18 C15.31,18 18,15.31 18,12 C18,10.34 17.33,8.84 16.24,7.76 L14.83,9.17 C15.55,9.9 16,10.9 16,12 C16,14.21 14.21,16 12,16 C9.79,16 8,14.21 8,12 C8,10.14 9.28,8.59 11,8.14 L11,10.28 C10.4,10.63 10,11.26 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,11.26 13.6,10.62 13,10.28 L13,2 L12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,9.24 20.88,6.74 19.07,4.93 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "Fill-1893"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.842,0.0499702058 C5.74366667,-0.0110300996 5.62066667,-0.0163634597 5.51766667,0.0349701307 L3,1.29397644 L0.482333333,0.0349701307 C0.379333333,-0.0163634597 0.256333333,-0.0110300996 0.158,0.0499702058 C0.06,0.110637176 0,0.217637712 0,0.333304958 L0,4.66665999 C0,4.80566069 0.0863333333,4.92999464 0.216333333,4.97899489 L2.883,5.97899989 C2.92066667,5.99299996 2.96033333,6 3,6 C3.03966667,6 3.07933333,5.99299996 3.117,5.97899989 L5.78366667,4.97899489 C5.91366667,4.92999464 6,4.80566069 6,4.66665999 L6,0.333304958 C6,0.217637712 5.94,0.110637176 5.842,0.0499702058 L5.842,0.0499702058 Z",
    fill: "#757575"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconCampaign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-campaign.88c7658b3159d9f74579b969157e9220.svg";